// extracted by mini-css-extract-plugin
module.exports = {"signer":"styles_signer__3ehUG","contact":"styles_contact__3KzPh","fullNameWrapper":"styles_fullNameWrapper__2fhwd","remove":"styles_remove__1lwdq"};